import React from "react";

/**
 * Red notification badge for unread message count.
 * Shows a dot (no number) when compact, or a count when not compact.
 */
export default function UnreadBadge({ count, compact = false, className = "" }) {
  if (!count || count <= 0) return null;

  if (compact) {
    return (
      <span
        className={`absolute top-0 right-0 w-[10px] h-[10px] bg-red-500 rounded-full border-2 border-[#0B0415] ${className}`}
      />
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[20px] h-[20px] px-[6px] text-[11px] font-bold text-white bg-red-500 rounded-full ${className}`}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
